import { useQuery } from '@tanstack/react-query';

import { assistantHistoryQueryKey } from 'ai/hooks/constants';
import type { AssistantHistory } from 'ai/types';
import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';

/* const mockfetchHistory = async (): Promise<Array<AssistantHistory>> => [
  {
    request: {
      id: '1',
      type: 'widget',
      payload: {
        widgetId: 'widget-123',
        viewId: 'dashboard-456',
        data: { key: 'value' },
      },
    },
    response: {
      text:
        'Here are some key insights from your “Very important data” widget:\n' +
        '\n' +
        '- March 2025 saw a major spike in New + Expansion revenue, especially in the New Business pipeline.\n' +
        '- The New Business pipeline is significantly outpacing Existing Business, generating nearly three times as much revenue per month.\n' +
        '- Both pipelines are trending upward, showing strong sales momentum and growing market demand.\n' +
        'Would you like to dive deeper into any specific pipeline, month, or strategy to capitalize on this growth? Or do you want recommendations on scaling your sales efforts based on these results?',
    },
  },
]; */

const fetchHistory = (): Promise<Array<AssistantHistory>> =>
  fetch('GET', qualifyUrl('/plugins/org.graylog.plugins.assistant/assistant'));

const useAssistantHistory = () => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: assistantHistoryQueryKey,
    queryFn: fetchHistory,
  });

  return { data, refetch, isLoading };
};

export default useAssistantHistory;
